/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { prepareEditorConfigForSnippet } from '../prepareEditorConfigForSnippet/prepareEditorConfigForSnippet';
import { getJsSourceTemplate } from '../getJsSourceTemplate/getJsSourceTemplate';
import { createElement } from '../createElement/createElement';
import {
	EDITOR_ANNOTATIONS_SIDEBAR_IDENTIFIER,
	EDITOR_CONTAINER_IDENTIFIER,
	EDITOR_MINIMAP_SIDEBAR_IDENTIFIER,
	EDITOR_OUTLINE_SIDEBAR_IDENTIFIER,
	EDITOR_PRESENCE_LIST_IDENTIFIER,
	EDITOR_REVISION_HISTORY_EDITOR_IDENTIFIER,
	EDITOR_REVISION_HISTORY_IDENTIFIER,
	EDITOR_REVISION_HISTORY_SIDEBAR_IDENTIFIER
} from '../../constants/identifiers';
import type { GetCodeGenericOptions } from '../getProjectFiles/types';

export function getCodeJs( {
	customerPortalAccount,
	editorOptions,
	evaluationLicense,
	selectedInstallMethod,
	selectedTechnology,
	isLoggedIn,
	hasPremiumPlugins,
	builderUrl
}: GetCodeGenericOptions ): string {
	const editorConfigContainers = {
		presenceList: createElement( EDITOR_PRESENCE_LIST_IDENTIFIER ),
		editorContainer: createElement( EDITOR_CONTAINER_IDENTIFIER ),
		revisionHistoryContainer: createElement( EDITOR_REVISION_HISTORY_IDENTIFIER ),
		revisionHistoryEditor: createElement( EDITOR_REVISION_HISTORY_EDITOR_IDENTIFIER ),
		revisionHistorySidebar: createElement( EDITOR_REVISION_HISTORY_SIDEBAR_IDENTIFIER ),
		outlineSidebar: createElement( EDITOR_OUTLINE_SIDEBAR_IDENTIFIER ),
		annotationsSidebar: createElement( EDITOR_ANNOTATIONS_SIDEBAR_IDENTIFIER ),
		minimapSidebar: createElement( EDITOR_MINIMAP_SIDEBAR_IDENTIFIER )
	};

	const editorConfig = prepareEditorConfigForSnippet( {
		editorOptions,
		selectedInstallMethod,
		selectedTechnology,
		editorConfigContainers,
		isLoggedIn,
		hasPremiumPlugins
	} );

	return getJsSourceTemplate( {
		customerPortalAccount,
		editorConfig,
		editorOptions,
		evaluationLicense,
		selectedInstallMethod,
		selectedTechnology,
		builderUrl
	} );
}
